import { FORM_BUILDER_FIELD_TYPE } from "@loanbossinc/component-library";

import { hedgeTypesForTypeAhead } from "../../../constants/hedgeTypes";

import { shouldShowMaxCapStrikeEdit, shouldShowPricingRequirements } from "./section-loan-hedge-requirements-rows-logic";
import { LOAN_HEDGE_REFERENCES } from "./section-loan-hedge-requirements-constants";

export const rows = {
  title: {
    isTitle: true,
    cells: [
      {
        type: FORM_BUILDER_FIELD_TYPE.TEXT,
        value: "Hedge Requirements",
        style: {
          marginLeft: "0",
          fontFamily: "Work Sans",
          fontStyle: "normal",
          fontWeight: "500",
          fontSize: "16px",
          lineHeight: "14px",
          textTransform: "uppercase",
          color: "#000000",
          marginBottom: "10px"
        }
      },
      {
        type: FORM_BUILDER_FIELD_TYPE.REFERENCE,
        referencedFieldPath: "loans.hedgerequirements.header"
      }
    ]
  },
  requiredHedge: {
    label: "Required Hedge",
    cells: [
      {
        type: FORM_BUILDER_FIELD_TYPE.TYPEAHEAD,
        name: "hedgeRequirements.requiredHedgeId",
        variant: "filled",
        options: hedgeTypesForTypeAhead,
        displayWith: option => option.name,
        setValueWith: option => option.value
      },
      {
        type: FORM_BUILDER_FIELD_TYPE.REFERENCE,
        referencedFieldPath: LOAN_HEDGE_REFERENCES.REQUIRED_HEDGE_ID
      }
    ]
  },
  notional: {
    label: "Notional",
    cells: [
      {
        type: FORM_BUILDER_FIELD_TYPE.DOLLAR,
        name: "hedgeRequirements.notional",
        variant: "filled"
      },
      {
        type: FORM_BUILDER_FIELD_TYPE.REFERENCE,
        referencedFieldPath: LOAN_HEDGE_REFERENCES.NOTIONAL
      }
    ]
  },
  termMonths: {
    label: "Term (Months)",
    cells: [
      {
        type: FORM_BUILDER_FIELD_TYPE.NUMBER,
        name: "hedgeRequirements.termMonths",
        variant: "filled"
      },
      {
        type: FORM_BUILDER_FIELD_TYPE.REFERENCE,
        referencedFieldPath: LOAN_HEDGE_REFERENCES.TERM_MONTHS
      }
    ]
  },
  maxCapStrike: {
    isVisible: data => shouldShowMaxCapStrikeEdit(data),
    label: "Max Cap Strike (Freddie)",
    cells: [
      {
        type: FORM_BUILDER_FIELD_TYPE.PERCENT,
        name: "hedgeRequirements.maxCapStrike",
        variant: "filled",
        decimals: 3
      },
      {
        type: FORM_BUILDER_FIELD_TYPE.REFERENCE,
        referencedFieldPath: LOAN_HEDGE_REFERENCES.MAX_CAP_STRIKE
      }
    ]
  },
  pricingRequirements: {
    isVisible: data => shouldShowPricingRequirements(data),
    label: "Pricing Requirements",
    cells: [
      {
        type: FORM_BUILDER_FIELD_TYPE.STRING,
        name: "hedgeRequirements.pricingRequirements",
        variant: "filled"
      },
      {
        type: FORM_BUILDER_FIELD_TYPE.REFERENCE,
        referencedFieldPath: LOAN_HEDGE_REFERENCES.PRICING_REQUIREMENTS
      }
    ]
  },
  ratingRequirements: {
    label: "Rating Requirements",
    cells: [
      {
        type: FORM_BUILDER_FIELD_TYPE.STRING,
        name: "hedgeRequirements.ratingsRequirements",
        variant: "filled"
      },
      {
        type: FORM_BUILDER_FIELD_TYPE.REFERENCE,
        referencedFieldPath: LOAN_HEDGE_REFERENCES.RATING_REQUIREMENTS
      }
    ]
  },
  extensions: {
    label: "Extensions",
    cells: [
      {
        type: FORM_BUILDER_FIELD_TYPE.STRING,
        name: "hedgeRequirements.extensions",
        variant: "filled"
      },
      {
        type: FORM_BUILDER_FIELD_TYPE.REFERENCE,
        referencedFieldPath: LOAN_HEDGE_REFERENCES.EXTENSIONS
      }
    ]
  },
  collateralAssignment: {
    label: "Collateral Assignment",
    cells: [
      {
        type: FORM_BUILDER_FIELD_TYPE.STRING,
        name: "hedgeRequirements.collateralAssignment",
        variant: "filled"
      },
      {
        type: FORM_BUILDER_FIELD_TYPE.REFERENCE,
        referencedFieldPath: LOAN_HEDGE_REFERENCES.COLLATERAL_ASSIGNMENT
      }
    ]
  },
  legalOpinion: {
    label: "Legal Opinion",
    cells: [
      {
        type: FORM_BUILDER_FIELD_TYPE.STRING,
        name: "hedgeRequirements.legalOpinion",
        variant: "filled"
      },
      {
        type: FORM_BUILDER_FIELD_TYPE.REFERENCE,
        referencedFieldPath: LOAN_HEDGE_REFERENCES.LEGAL_OPINION
      }
    ]
  },
  executionRequirements: {
    label: "Execution Requirements",
    cells: [
      {
        type: FORM_BUILDER_FIELD_TYPE.STRING,
        name: "hedgeRequirements.executionRequirements",
        variant: "filled"
      },
      {
        type: FORM_BUILDER_FIELD_TYPE.REFERENCE,
        referencedFieldPath: LOAN_HEDGE_REFERENCES.EXECUTION_REQUIRENMENTS
      }
    ]
  },
  misc: {
    label: "Misc.",
    cells: [
      {
        type: FORM_BUILDER_FIELD_TYPE.STRING,
        name: "hedgeRequirements.misc",
        variant: "filled"
      },
      {
        type: FORM_BUILDER_FIELD_TYPE.REFERENCE,
        referencedFieldPath: LOAN_HEDGE_REFERENCES.MISC
      }
    ]
  }
};
